import json from "../../json/salesforceQuota.json";

export default async () => JSON.parse(JSON.stringify(await json));
